import { createContext, useContext } from 'react';

export type SettingsHubContextValue = {
  isOpen: boolean;
  /** Opens the hub, optionally jumping straight to a group (e.g. the profile menu's Admin row). */
  openSettings: (groupId?: string) => void;
  closeSettings: () => void;
};

export const SettingsHubContext = createContext<SettingsHubContextValue | undefined>(undefined);

export const useSettingsHub = (): SettingsHubContextValue => {
  const context = useContext(SettingsHubContext);

  if (!context) {
    throw new Error('useSettingsHub must be used within a SettingsHubProvider');
  }

  return context;
};
